import React from 'react';
import './style.css';
import Select from 'rc-select';

const SelectStyle = ({ children, ...rest }) => (
  <Select className="select-style" {...rest}>
    {children}
  </Select>
);

export default SelectStyle;
